// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import VueMoment from 'vue-moment'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(Vuetify)
Vue.use(VueMoment)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBxn4o44Ur9bz_iEVHB_UDH2kw9YU9uHCw',
    libraries: 'places',
  }
});

import('vuetify/dist/vuetify.min.css')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js